import { get, post, put, patch, del } from './client'

/** 与后端订阅套餐（SubscriptionPlan）JSON 字段对齐 */
export interface SubscriptionPlan {
  id: number
  title: string
  subtitle?: string
  price_amount: number
  currency: string
  duration_unit: string
  duration_value: number
  custom_seconds: number
  enabled: boolean
  sort_order: number
  stripe_price_id?: string
  creem_product_id?: string
  max_purchase_per_user: number
  upgrade_group?: string
  total_amount: number
  quota_reset_period: string
  quota_reset_custom_seconds: number
  created_at?: number
  updated_at?: number
}

export interface SubscriptionPlanRow {
  plan: SubscriptionPlan
}

/**
 * 管理员：套餐列表
 * GET /api/subscription/admin/plans → data: { plan: SubscriptionPlan }[]
 */
export async function listAdminSubscriptionPlansApi(): Promise<SubscriptionPlanRow[]> {
  return get<SubscriptionPlanRow[]>('/api/subscription/admin/plans')
}

/**
 * 创建套餐
 * POST /api/subscription/admin/plans body: { plan: Partial<SubscriptionPlan> }
 */
export async function createAdminSubscriptionPlanApi(plan: Partial<SubscriptionPlan>): Promise<SubscriptionPlan> {
  return post<SubscriptionPlan>('/api/subscription/admin/plans', { plan })
}

/**
 * 更新套餐
 * PUT /api/subscription/admin/plans/:id
 */
export async function updateAdminSubscriptionPlanApi(
  id: number,
  plan: Partial<SubscriptionPlan>
): Promise<void> {
  return put(`/api/subscription/admin/plans/${id}`, { plan })
}

/**
 * 仅更新启用状态
 * PATCH /api/subscription/admin/plans/:id body: { enabled: boolean }
 */
export async function patchSubscriptionPlanEnabledApi(id: number, enabled: boolean): Promise<void> {
  return patch(`/api/subscription/admin/plans/${id}`, { enabled })
}

// ---- 管理员：用户订阅实例（供用户页等调用）----

/** 与后端 `SubscriptionSummary` 一致 */
export interface UserSubscriptionSummaryRow {
  subscription?: {
    id: number
    user_id: number
    plan_id: number
    amount_total?: number
    amount_used?: number
    start_time?: number
    end_time?: number
    status?: string
    [key: string]: unknown
  }
}

/**
 * GET /api/subscription/admin/users/:id/subscriptions
 */
export async function listUserSubscriptionsAdminApi(
  userId: number
): Promise<UserSubscriptionSummaryRow[]> {
  return get<UserSubscriptionSummaryRow[]>(`/api/subscription/admin/users/${userId}/subscriptions`)
}

/**
 * POST /api/subscription/admin/users/:id/subscriptions body: { plan_id: number }
 */
export async function adminBindUserSubscriptionApi(userId: number, planId: number): Promise<void> {
  return post(`/api/subscription/admin/users/${userId}/subscriptions`, { plan_id: planId })
}

/**
 * POST /api/subscription/admin/user_subscriptions/:id/invalidate
 */
export async function adminInvalidateUserSubscriptionApi(subscriptionId: number): Promise<void> {
  return post(`/api/subscription/admin/user_subscriptions/${subscriptionId}/invalidate`, {})
}

/**
 * DELETE /api/subscription/admin/user_subscriptions/:id
 */
export async function adminDeleteUserSubscriptionApi(subscriptionId: number): Promise<void> {
  return del(`/api/subscription/admin/user_subscriptions/${subscriptionId}`)
}
